<!-- ================= SKELETON PLACEHOLDER ================= -->
<div class="movie-details-container details-skeleton-container" *ngIf="isLoading || !tvData">
  <div class="backdrop-image-container skeleton-backdrop-bg">
    <div class="skeleton-shimmer"></div>
  </div>
  <div class="movie-details">
    <div class="movie-poster-skeleton">
      <div class="skeleton-shimmer"></div>
      <div class="poster-skeleton-icon">
        <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
          <rect x="2" y="2" width="20" height="20" rx="3" ry="3"></rect>
          <circle cx="8.5" cy="8.5" r="1.5"></circle>
          <polyline points="21 15 16 10 5 21"></polyline>
        </svg>
      </div>
    </div>
    <div class="movie-info movie-info-skeleton">
      <div class="skeleton-bar skeleton-title-bar">
        <div class="skeleton-shimmer"></div>
      </div>
      <div class="movie-metadata skeleton-meta-row">
        <div class="skeleton-circle-rating">
          <div class="skeleton-shimmer"></div>
        </div>
        <div class="skeleton-bar skeleton-year-bar">
          <div class="skeleton-shimmer"></div>
        </div>
        <div class="skeleton-bar skeleton-genre-bar">
          <div class="skeleton-shimmer"></div>
        </div>
      </div>
      <div class="skeleton-overview-group">
        <div class="skeleton-bar skeleton-desc-line desc-line-1"><div class="skeleton-shimmer"></div></div>
        <div class="skeleton-bar skeleton-desc-line desc-line-2"><div class="skeleton-shimmer"></div></div>
        <div class="skeleton-bar skeleton-desc-line desc-line-3"><div class="skeleton-shimmer"></div></div>
      </div>
      <div class="skeleton-btn-trailer">
        <div class="skeleton-shimmer"></div>
      </div>
    </div>
  </div>
</div>

<!-- ================= LOADED CONTENT ================= -->
<div class="movie-details-container" *ngIf="!isLoading && tvData">
  <div class="backdrop-image-container" id="backdropContainer" [ngStyle]="{'background-color':middleColor}">
    <img *ngIf="tvData?.backdrop_path" #backdropImage class="movie-backdrop-image" id="backdropImage"
      [src]="backendServer + '/proxy?url=' + encodeURIComponent('https://image.tmdb.org/t/p/w1280' + tvData.backdrop_path)"
      (load)="onImageLoad(backdropImage)" alt="TV backdrop" crossorigin="anonymous"
      fetchpriority="high" loading="eager" decoding="async">
  </div>
  <div class="movie-details">
    <div class="movie-poster-wrapper">
      <div class="poster-placeholder" *ngIf="!posterLoaded">
        <div class="skeleton-shimmer"></div>
        <div class="poster-skeleton-icon">
          <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
            <rect x="2" y="2" width="20" height="20" rx="3" ry="3"></rect>
            <circle cx="8.5" cy="8.5" r="1.5"></circle>
            <polyline points="21 15 16 10 5 21"></polyline>
          </svg>
        </div>
      </div>
      <img *ngIf="tvData?.poster_path" class="movie-poster"
        [class.loaded]="posterLoaded"
        [src]="'https://image.tmdb.org/t/p/w500' + tvData.poster_path"
        [alt]="tvData?.title || tvData?.name || 'TV poster'"
        width="300" height="450"
        fetchpriority="high" loading="eager" decoding="async"
        (load)="posterLoaded = true"
        (error)="onImageError($event)">
    </div>
    <div class="movie-info">
      <h1 class="movie-title">{{ tvData?.title || tvData?.name || tvData?.original_title ||
        tvData?.original_name }}</h1>
      <div class="movie-metadata">
        <div class="ratings-container">
          <div class="ratings-circle-container">
            <div class="ratings-circle">
              <span class="ratings-text">{{ filterRating(tvData?.vote_average) }} %</span>
            </div>
          </div>
        </div>
        <span class="movie-year">{{ tvData?.release_date || tvData?.first_air_date }}</span>
        <span class="movie-genre">
          <ng-container *ngFor="let genre of tvData?.genres; let last = last">
            {{ genre?.name }}<span *ngIf="!last">, </span>
          </ng-container>
        </span>
      </div>
      <p class="movie-overview" [attr.title]="tvData?.overview">
        {{ triptContent(tvData?.overview) }}
      </p>
      <button class="movie-trailer" (click)="playTrailer()">{{ languageService.t('playTrailer') }}</button>
    </div>
  </div>
</div>
